import { useMandatorContext } from "@rentablo/theming";

const ISIN_REQUIRED_MANDATORS: string[] = ["kpmg-germany"];

interface IsinValidatable {
  isin?: string;
  hasValidIsin?: boolean;
  quoteProvider?: string;
}

export const useIsinValidation = (item: IsinValidatable) => {
  const { mandatorSlug } = useMandatorContext();
  const isCrypto = item.quoteProvider === "crypto";
  const isIsinRequired =
    ISIN_REQUIRED_MANDATORS.includes(mandatorSlug) && !isCrypto;
  const isIsinValid =
    isCrypto || (Boolean(item.isin?.length) && Boolean(item.hasValidIsin));

  return { isIsinRequired, isIsinValid };
};

export const isIsinError = (error: AxiosApiError | null): boolean => {
  const errors = error?.response?.data?.errors ?? [];

  return errors.some(
    ({ code, message }) =>
      code === "VALIDATION_ERROR" && message?.toUpperCase().includes("ISIN")
  );
};
